module.exports = __webpack_public_path__ + "static/media/140.e0a92b0d.png";